/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Oas20Definitions } from '../models/Oas20Definitions';
import { Oas20Headers } from '../models/Oas20Headers';
import { Oas20Items } from '../models/Oas20Items';
import { Oas20ParameterDefinitions } from '../models/Oas20ParameterDefinitions';
import { Oas20ResponseDefinitions } from '../models/Oas20ResponseDefinitions';
import { Oas20Scopes } from '../models/Oas20Scopes';
import { Oas20SecurityDefinitions } from '../models/Oas20SecurityDefinitions';
import { IOasVisitor } from '../../visitors/IOasVisitor';

/**
 * The OpenAPI 2.0 version of the visitor interface.
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IOas20Visitor extends IOasVisitor {
    visitItems(node : Oas20Items);

    visitScopes(node : Oas20Scopes);

    visitSecurityDefinitions(node : Oas20SecurityDefinitions);

    visitDefinitions(node : Oas20Definitions);

    visitParameterDefinitions(node : Oas20ParameterDefinitions);

    visitHeaders(node : Oas20Headers);

    visitResponseDefinitions(node : Oas20ResponseDefinitions);
}


